import { ReactNode } from 'react';

import { Navigate } from 'react-router';

import { useSuspenseGetContext } from '../../../../api/lending/lapiHooks.suspense';
import { SIGNUP_BASE_PATH } from '../../../Signup/routes';
import { buildQueryString } from '../../../utils/queryParams';

/**
 * Redirects buyers who haven't completed signup back to the signup flow.
 *
 * A returning customer who only completed step 0 on a pay-link landing
 * will arrive here with an open application but no onboarding data —
 * the backend cannot make a decision, so the dashboard would show a
 * misleading "pending" screen. This guard catches that case early.
 */
export function SignupGuard({ children }: { children: ReactNode }) {
  const { context } = useSuspenseGetContext({ throwIfNotLoggedIn: false });

  if (context.isLoggedIn && !context.user_signup_finished) {
    return <Navigate to={`${SIGNUP_BASE_PATH}${buildQueryString()}`} replace />;
  }

  return children;
}
